import { Navigate, Outlet } from "react-router-dom";

const PublicRoutesOutlet = () => {
  const auth = { token: sessionStorage.getItem("sal_token") };
  // const auth = { token: "Authenticated" };
  // const auth = { token: null };
  return !auth.token ? (
    <>
      {/* Header | Footer | Drawer for Protected Routes add here */}
      {/* <header className="App-header">
        <Login />
      </header> */}
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default PublicRoutesOutlet;
